import { render, staticRenderFns } from "./LawTypeOfViolationList.vue?vue&type=template&id=c5281c1c&"
import script from "./LawTypeOfViolationList.vue?vue&type=script&lang=js&"
export * from "./LawTypeOfViolationList.vue?vue&type=script&lang=js&"
import style0 from "./LawTypeOfViolationList.vue?vue&type=style&index=0&id=c5281c1c&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports